import { ChatContentPage } from "components/chat/ChatContentPage";
import { NavigationPanel } from "components/navigationPanel/NavigationPanel";
import { designTokens } from "theme/customTheme";

const styles = {
  container: {
    display: "flex",
    height: "100dvh",
    overflow: "hidden",
    backgroundColor: designTokens.neutral[50],
  } as React.CSSProperties,
  navPanel: {
    display: "flex",
    flexShrink: 0,
    height: "100dvh",
    backgroundColor: designTokens.neutral[50],
  } as React.CSSProperties,
  contentContainer: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minWidth: 0,
    height: "100dvh",
    boxSizing: "border-box",
    overflow: "hidden",
  } as React.CSSProperties,
};

export const ChatPage = (): JSX.Element => {
  return (
    <div className="App" style={styles.container}>
      <div style={styles.navPanel}>
        <NavigationPanel />
      </div>
      <div style={styles.contentContainer}>
        <ChatContentPage />
      </div>
    </div>
  );
};
